export default __webpack_public_path__ + "static/media/pool-1.8535abd1.jpeg";